var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_30230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1829 17.6586C22.4733 15.9032 24.9894 14.5658 25.2044 14.4613C25.8926 14.106 26.6023 13.1656 25.2044 12.4342C24.7528 12.2043 22.3227 10.9086 19.1829 9.23682L14.8604 13.4582L19.1829 17.6586Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8602 13.4583L1.05371 26.9791C1.37629 27.0209 1.74188 26.9374 2.17199 26.7075C3.07522 26.2268 12.6666 21.1278 19.1827 17.6587L14.8602 13.4583Z",
    fill: "#FF3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8602 13.4583L19.1828 9.23694C19.1828 9.23694 3.13975 0.731522 2.17201 0.229974C1.80642 0.0209961 1.39782 -0.0416974 1.03223 0.0209961L14.8602 13.4583Z",
    fill: "#48FF48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8602 13.4583L1.03226 0.0209961C0.473118 0.146383 0 0.627035 0 1.60923C0 3.17657 0 24.0744 0 25.391C0 26.2896 0.365592 26.9374 1.05376 27.0001L14.8602 13.4583Z",
    fill: "#3BCCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_30230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/android-icon.087e02f369956f4e836d4bfb23aa5d80.svg";
export { ForwardRef as ReactComponent };